import axios from "../../utils/axios";
import { buildQueryStringList } from "../../utils/stringUtils";
import type { NonUser } from "../types/commonDtos";
import type { IncidentCategoryDTO, IncidentDTO } from "../types/incidentDtos";
import type { AccountTreeDTO } from "../types/miscServiceDtos";


const accountEndpointUrl = `${process.env.REACT_APP_MYWORKNEST_API_URL}/Account`;
const apiUrl = process.env.REACT_APP_HS_API_URL;

const fetchNonUser = (nonUserRef) => {
    return axios.get<NonUser>(
        `${apiUrl}/NonUser/Get`, {
        params: {
            nonUserRef: nonUserRef
        }
    }
    );
}

const addNonUser = (nonUser) => {
    return axios.post<NonUser>(`${apiUrl}/NonUser/Add`, nonUser);
}

const fetchIncidentCategories = () =>
    axios.get<IncidentCategoryDTO[]>(`${apiUrl}/nonuser/incidentCategories`);

const addIncident = (incident) => {
    return axios.post<IncidentDTO>(`${apiUrl}/NonUser/NewIncident`, incident);
}

const addAction = (action) => {
    const formData = new FormData();

    formData.append("description", action.description);
    formData.append("siteExternalId", action.siteExternalId);
    formData.append("rating", String(action.rating ?? 1));

    formData.append("NonUser.Name", action.name);
    formData.append("NonUser.Email", action.email);
    formData.append("NonUser.Phone", action.phone);

    if (action.attachments && action.attachments.length > 0) {
        action.attachments.forEach((attachment) => {
            formData.append("attachmentList", attachment); 
        });
    }

    // Deferred: backend returns the raw `Data.Models.Action` EF entity graph
    // (saveResult.Value), not the documented ActionDTO. See summary note.
    return axios.post(`${apiUrl}/NonUser/NewAction`, formData, {
        headers: {
            "Content-Type": "multipart/form-data",
        },
    });
};

const nonUserService = {
    fetchNonUser,
    addNonUser,
    addIncident,
    fetchIncidentCategories,
    addAction,
    // Deferred: no matching backend route found for `/nonuser/templates`
    // (NonUserController has no `templates` action). Possible dead/broken call.
    fetchTemplates: (externalId) =>
        axios.get(`${apiUrl}/nonuser/templates`, {
            params: { externalId }
        }),

    // Deferred: returns IncidentTemplateDTO (deep TemplateVersion graph).
    fetchIncidentFormVersion: (templateVersionId, externalId) =>
        axios.get(`${apiUrl}/NonUser/TemplateVersionAndInvestigation/${templateVersionId}`, {
            params: {
                externalId
            }
        }),

    // Deferred: returns TemplateDTO[] (deep template/question graph).
    fetchAllTemplatesForModule: ({ moduleArea, accountId, siteExternalIds, includeDisabled }) => {
        const sitesList = buildQueryStringList("siteExternalIds", siteExternalIds);
        return axios.get(
            `${apiUrl}/NonUser/ApplicationArea/All/${moduleArea}${sitesList}&accountId=${accountId}&includeDisabled=${includeDisabled}`
      );
    },

    fetchAccountAppSites: ({ parentExternalId }) => {
        return axios.get<AccountTreeDTO[]>(`${accountEndpointUrl}/AccountTree/SafetyNest/${parentExternalId}`);
    },
    
};

export default nonUserService;